import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import parsePhoneNumber, { getCountryCallingCode, getExampleNumber, isSupportedCountry, } from 'libphonenumber-js';
import examples from 'libphonenumber-js/examples.mobile.json';
import { Icon } from '../Icon';
import { Dropdown } from '../Dropdown';
import { Input } from './Input';
const Label = styled.div `
  display: flex;
  gap: 4px;
  align-items: center;
  font-size: 14px;
  font-weight: var(--font-regular, 500);
  color: ${({ theme }) => theme.secondary.background};
`;
const Up = styled(Icon.ChevronUpLarge) `
  --icon-size: 14px;
  --icon-color: currentColor;

  pointer-events: none;
`;
const Down = styled(Icon.ChevronDownLarge) `
  --icon-size: 14px;
  --icon-color: currentColor;

  pointer-events: none;
`;
const StyledDropdown = styled(Dropdown) `
  --dropdown-custom-padding: 0;
`;
const Dial = styled.div `
  white-space: nowrap;
  line-height: 16px;
`;
export const CountryCodeSelector = ({ countryList, onChange, size }) => {
    const [country, setCountry] = useState({ code: 'US', dial: '+1' });
    const [countryOpen, setCountryOpen] = useState(false);
    return (React.createElement("div", { style: { display: 'flex' } },
        React.createElement(StyledDropdown, { options: countryList.map((c) => ({
                label: `${c.name} (+${c.dial.replace('+', '')})`,
                value: c.code,
            })), active: country.code, onChange: (value) => {
                const selected = countryList.find(({ code }) => code === value?.toString());
                if (!selected) {
                    return;
                }
                const newCountry = {
                    code: selected.code,
                    dial: isSupportedCountry(selected.code)
                        ? `+${getCountryCallingCode(selected.code)}`
                        : selected.dial.replace(/\s+/g, ''),
                };
                setCountry(newCountry);
                onChange(newCountry);
            }, onOpenChange: setCountryOpen, customLabel: React.createElement(Label, null,
                country.code,
                countryOpen ? React.createElement(Up, null) : React.createElement(Down, null)), offsetX: size === 'small' ? -12 : -16, offsetY: size === 'small' ? 4 : 12, search: true }),
        React.createElement(Dial, null, country.dial)));
};
export const PhoneInput = (props) => {
    const [value, setValue] = useState(props.value ?? '');
    const [lastCountry, setLastCountry] = useState(undefined);
    const [country, setCountry] = useState({ code: 'US', dial: '+1' });
    const trimCountryCodes = useCallback((input) => {
        let output = input.replace(country.dial, '');
        if (lastCountry) {
            output = output.replace(lastCountry.dial, '');
        }
        return output;
    }, [country, lastCountry]);
    const updateCountry = useCallback((newCountry) => {
        setLastCountry(country);
        setCountry(newCountry);
        const nextValue = newCountry.dial + trimCountryCodes(value);
        setValue(nextValue);
        if (props.onChange) {
            props.onChange(nextValue);
        }
    }, [country, trimCountryCodes, value]);
    const handleChange = useCallback((v) => {
        const nextValue = country.dial + v;
        setValue(nextValue);
        if (props.onChange) {
            props.onChange(nextValue);
        }
    }, [country, props.onChange]);
    useEffect(() => {
        if (!props.value) {
            return;
        }
        const phoneNumber = parsePhoneNumber(props.value);
        setValue(props.value);
        if (phoneNumber && phoneNumber.country) {
            setCountry({
                code: phoneNumber.country,
                dial: `+${phoneNumber.countryCallingCode}`,
            });
        }
    }, [props.value]);
    const inputValue = useMemo(() => trimCountryCodes(value), [trimCountryCodes, value]);
    return (React.createElement(Input, { ...props, onChange: handleChange, pattern: "^[0-9]*$", placeholder: props.placeholder ?? getExampleNumber(country.code, examples)?.nationalNumber, type: 'tel', value: inputValue, valuePrefix: React.createElement(CountryCodeSelector, { countryList: props.countryList, onChange: updateCountry, size: props.size }) }));
};
//# sourceMappingURL=Phone.js.map